export default {
  "nav.home": "首頁",
  "nav.scenarios": "使用場景",
  "nav.systems": "九大系統",
  "nav.engine": "核心能力",
  "nav.faq": "常見問題",
  "nav.download_now": "立即下載",
  "nav.back_home": "返回首頁",
  "nav.switch_language": "切換語言",
  "banner.text": "立即下載命理乾坤 APP，隨時隨地探索命理奧秘",
  "banner.google_play": "Google Play",
  "banner.app_store": "App Store",
  "banner.close": "關閉提示",
  "download.title": "下載命理乾坤 APP",
  "download.subtitle": "選擇適合你的下載渠道",
  "download.google_play": "Google Play",
  "download.app_store": "App Store",
  "download.apk": "下載 APK 安裝包",
  "download.apk_hint": "Android 裝置適用",
  "download.coming_soon": "敬請期待",
  "hero.badge": "AI 命理推演引擎",
  "hero.title1": "洞悉命理",
  "hero.title2": "掌控乾坤",
  "hero.title3": "紫微 · 八字 · 奇門 · · ·",
  "hero.subtitle": "——做自己命運的主宰者",
  "hero.desc_title": "排盤・推演・洞察",
  "hero.desc": "內藏紫微斗數、八字命理、六爻、奇門、星座、塔羅等融合中西方九大命理流派，內建 250+ 客製化命盤工具。多Agent協作架構，可視化推理流程，每一步分析透明可追溯。",
  "hero.cta": "馬上體驗",
  "scenarios.bg_text": "關鍵時刻",
  "scenarios.title": "那些你可能問過自己不止一次的問題",
  "scenarios.subtitle": "在關鍵時刻，看清你的處境",
  "scenarios.item1.tag": "探索可能",
  "scenarios.item1.title": "堅守原地，\n還是另尋新徑？",
  "scenarios.item1.desc": "喧囂聲中，你內心的光從未熄滅。發現被他人忽視的能量，將你的天賦與機遇對齊，踏上真正屬於你的軌跡。",
  "scenarios.item1.tags": "潛能發現,趨勢分析,時機建議",
  "scenarios.item2.tag": "情感洞察",
  "scenarios.item2.title": "靈魂伴侶，\n還是命中試煉？",
  "scenarios.item2.desc": "超越對關係的單一標籤。解構能量場如何交織與重塑。發現隱藏的羈絆與頓悟時刻——關於自己，關於他人，關於從不確定性深處升起的寧靜自信。",
  "scenarios.item2.tags": "能量匹配,羈絆深度,溝通窗口",
  "scenarios.item3.tag": "風險機遇",
  "scenarios.item3.title": "避開暗礁，\n還是盲闖風暴？",
  "scenarios.item3.desc": "命運不承諾坦途，也不刻意設伏。照亮前方的璀璨與暗流，在人生的關鍵節點看清何時借勢而起、何時明智退避。",
  "scenarios.item3.tags": "風險預警,機遇捕捉,週期感知",
  "showcase.bg_text": "產品",
  "showcase.title": "以大師之智思考\n以工程師之嚴謹交付",
  "showcase.subtitle": "多Agent AI分析系統",
  "showcase.desc": "復現大師級推理能力，融合社會現實與天時宇宙。在你人生旅途的每一段經歷與抉擇中，找到獨一無二的你。多個專業AI Agent協同作業，每一步推理都追求嚴謹與透明。",
  "systems.title": "九式合一，每一步皆可驗證",
  "systems.subtitle": "十大命理體系交叉驗證，250+ 核心玄學分析專用工具",
  "systems.stat_systems": "命理體系",
  "systems.stat_tools": "客製推演工具",
  "systems.scroll_hint": "左右滑動查看更多",
  "systems.scroll_left": "向左滑動",
  "systems.scroll_right": "向右滑動",
  "systems.learn_more": "了解詳情",
  "systems.item1.name": "八字命理",
  "systems.item1.en": "四柱命理",
  "systems.item1.desc": "以天干地支與陰陽五行為基石，推演先天命格、大運流年，洞見人生起伏與趨勢走向。",
  "systems.item2.name": "紫微斗數",
  "systems.item2.en": "紫微神數",
  "systems.item2.desc": "以十二宮位與百餘星曜構建命盤，細膩刻畫性格、事業、情感，被譽為天下第一神數。",
  "systems.item3.name": "周易占卜",
  "systems.item3.en": "易經占卜",
  "systems.item3.desc": "六十四卦包羅萬象，以蓍草或數字起卦，在變化中捕捉天地人三才的玄機與啟示。",
  "systems.item4.name": "生肖運勢",
  "systems.item4.en": "十二生肖",
  "systems.item4.desc": "以十二生肖與地支流年為脈絡，解讀每年吉凶方位、貴人小人，把握年度行事節奏。",
  "systems.item5.name": "七政四餘",
  "systems.item5.en": "古星命學",
  "systems.item5.desc": "傳承古天文星命學，以日月五星與四餘星之運行，參詳命主氣運與時代氣脈的交匯。",
  "systems.item6.name": "相學解讀",
  "systems.item6.en": "面相手相",
  "systems.item6.desc": "面相藏福禍，手紋寫春秋。以五官形質與掌紋紋理，辨識先天稟賦與後天際遇。",
  "systems.item7.name": "運勢週期",
  "systems.item7.en": "大運流年",
  "systems.item7.desc": "十年一大運，一歲一流年。精準標註人生關鍵節點，讓你在正確的時間做正確的選擇。",
  "systems.item8.name": "星座占卜",
  "systems.item8.en": "黃道占星",
  "systems.item8.desc": "以黃道十二宮與行星相位為鏡，透視性格原型與情感模式，融合東西方智慧互補驗證。",
  "systems.item9.name": "塔羅排盤",
  "systems.item9.en": "塔羅牌陣",
  "systems.item9.desc": "七十八張神秘牌陣，連接潛意識與集體無意識，在象徵與隱喻中發現當下的深層指引。",
  "systems.item10.name": "解夢心理",
  "systems.item10.en": "夢境解析",
  "systems.item10.desc": "夢是通往潛意識的皇家大道。解析夢境符號與情緒線索，揭示內心深處的渴望與預警。",
  "engine.title": "不止於解讀——更是推演",
  "engine.subtitle": "命理乾坤引擎的核心能力——從Agent協作、可視化推理到幻覺抑制與知識溯源——構建嚴謹的命理分析閉環。",
  "engine.item1.title": "統一Agent架構",
  "engine.item1.desc": "網頁搜尋、命盤排盤、報告撰寫、即時數據增強——多能力模組在統一框架下協同作業。命理洞察與行業趨勢並置輸出，為複合決策提供支撐。",
  "engine.item2.title": "可視化推理",
  "engine.item2.desc": "從時間校準、命盤建模到多派融合，每一步推理完全可見——可追溯、可審計。你看到的不僅是結論，而是它如何一步步被推導出來。",
  "engine.item3.title": "精選知識庫",
  "engine.item3.desc": "知識庫源自經典文獻與驗證方法論，嚴格過濾低質網路內容與錯誤解讀。分析忠於命盤本身，而非模型臆測。",
  "engine.item4.title": "漸進式推理",
  "engine.item4.desc": "通過幻覺抑制與漸進線索收集，系統主動發現命盤中的關鍵信號而非臆測。每一次推斷都建立在累積證據之上，而非隨機模型輸出。",
  "engine.item5.title": "比您更懂您",
  "engine.item5.desc": "多維命理模型深度刻畫您的性格底色、潛在需求與決策模式，洞察您未曾察覺的內在傾向。不僅回應提問，更能預判您真正關心的方向——推演結果隨著每一次交互愈發貼合真實的您。",
  "engine.item6.title": "時間線錨定",
  "engine.item6.desc": "即使同一時刻出生的人，人生軌跡也大相逕庭。系統記錄你生命中每一段重要經歷與關鍵抉擇，錨定時間線，讓推演真正反映你獨特的人生旅程。",
  "faq.bg_text": "問答",
  "faq.title": "常見問題",
  "faq.subtitle": "關於命理乾坤的方法論、使用方式與數據安全",
  "faq.item1.q": "如何正確理解命理分析的結果？",
  "faq.item1.a": "命理分析系統推演的是先天運勢的傾向，而非確定性的結論。一個人的實際境遇由三大因素共同塑造：先天命盤、地運和人運。地運關乎時代與社會環境，非個人可控。人運則取決於你在關鍵時刻的應對與決策。所謂趨吉避凶，本質上是在了解運勢傾向後，主動優化決策，以追求更有利的結果。",
  "faq.item2.q": "命理乾坤與普通算命App有何不同？",
  "faq.item2.a": "多數算命App本質上是模板填充器——輸入生日，獲得幾段預先寫好的、換個人也幾乎不變的文本。命理乾坤同時運行多個專業Agent，分別負責排盤、符號提取、跨派驗證與報告合成。融合紫微斗數、八字、奇門遁甲三大體系，配備250+客製命盤工具，且每一步推理都透明可見。",
  "faq.item3.q": "不熟悉玄學術語，能看懂報告嗎？",
  "faq.item3.a": "可以。報告面向非專業讀者設計，所有玄學術語均轉化為平實語言。結構化的呈現——關鍵結論、詳細分析、行動建議——如同一份標準諮詢報告，易於理解。",
  "faq.item4.q": "AI真的能理解主觀的命運問題嗎？",
  "faq.item4.a": "命理乾坤定位為決策輔助工具，而非命運預測者。系統從嚴謹策展的知識庫出發推理，同時納入即時網路數據作為補充參考。它幫助你系統評估處境、發現被忽視的變量、建立多視角思考框架。最終決策始終屬於你。",
  "faq.item5.q": "我的出生日期等隱私數據安全嗎？",
  "faq.item5.a": "我們採用雙重加密進行傳輸與儲存，執行嚴格的存取控制與身份認證，並定期開展安全評估。報告生成後，個人身份信息將被匿名化處理——僅保留命盤結構與推理輸出用於系統優化。用戶數據絕不向第三方出售。",
  "faq.item6.q": "紫微斗數和八字是什麼？",
  "faq.item6.a": "八字（四柱）約形成於宋代，以天干地支在陰陽五行框架中解讀出生時間。紫微斗數亦起源於北宋，由古代占星術演化而來。二者均為最廣為流傳的命理分析體系，歷經千年沉澱與完善。命理乾坤融合兩大體系與奇門遁甲，通過多派交叉驗證實現更全面的分析。",
  "faq.item7.q": "命理乾坤支持哪些命理流派？",
  "faq.item7.a": "當前支持：紫微斗數（欽天四化體系）、八字（四柱命理）與奇門遁甲。系統通過交叉驗證降低單派解讀偏差，並運用機率模型調和各派之間的分歧結論。",
  "faq.item8.q": "分析報告包含哪些內容？",
  "faq.item8.a": "每份報告包含：基礎命盤結構解讀、大限流年趨勢分析、針對你具體問題的定向推演、多派交叉驗證結論，以及基於分析的行動建議。所有推理步驟在報告中均可追溯。",
  "footer.cta_title": "準備好探索你的命盤了嗎？",
  "footer.cta_subtitle": "開始一場真正深入的命理分析對話",
  "footer.cta_button": "立即開始推演",
  "footer.brand_slogan": "\"洞悉命理，掌控乾坤\"",
  "footer.about": "關於",
  "footer.about_us": "關於我們",
  "footer.contact_us": "聯繫我們",
  "footer.legal": "法律",
  "footer.privacy": "隱私政策",
  "footer.terms": "服務條款",
  "footer.copyright": "{{year}} {{brand}}。保留所有權利。",

  // privacy page
  "privacy.back_home": "返回首頁",
  "privacy.title": "隱私政策",
  "privacy.subtitle": "隱私政策",
  "privacy.banner_alt": "隱私保護",
  "privacy.banner_title": "我們承諾保護您的隱私",
  "privacy.banner_desc": "您的個人資訊和命理資料，由我們嚴格保密",
  "privacy.badge1": "加密儲存",
  "privacy.badge2": "不售個資",
  "privacy.badge3": "尊重自主",
  "privacy.disclaimer_title": "命理資料使用聲明",
  "privacy.disclaimer_p1": "您提供的生辰八字、出生地點、星座等一切命理資料，僅供娛樂性命理演算使用，不代表任何形式的專業測評或價值判斷，不可作為現實決策依據。",
  "privacy.disclaimer_b1": "我們依照嚴格的資料保護標準管理您的個人資訊，保障您的隱私安全。",
  "privacy.disclaimer_b2": "運勢分析是順勢而為的參考，命理是認識自我的工具，而非束縛命運的枷鎖。",
  "privacy.disclaimer_b3": "遇到不利運勢，我們理性分析並提供化解之道，不恐嚇、不製造焦慮。",
  "privacy.contact_title": "隱私相關查詢",
  "privacy.contact_desc": "如您對本隱私政策有任何疑問，或希望行使您的個人資料權利，請聯繫我們的資料保護團隊：",
  "privacy.contact_note": "我們將盡快在3個工作日內回覆您的請求。",
  "privacy.sec1.title": "一、資訊收集",
  "privacy.sec1.body": "我們收集的資訊包括：\n• 帳號資訊：姓名、出生日期、手機號碼或電子郵件地址\n• 命理資料：您主動提供的出生時間、出生地點、性別等資訊，用於命理計算\n• 設備資訊：設備型號、作業系統版本、應用版本號\n• 使用資料：您在應用內的操作記錄，用於改善用戶體驗\n• 支付資訊：支付流水號（我們不儲存您的完整支付卡資訊）",
  "privacy.sec2.title": "二、資訊使用",
  "privacy.sec2.body": "我們使用您的資訊用於：\n• 提供命理計算、占卜分析等核心服務（純屬娛樂性質，不構成任何專業建議）\n• 個性化您的應用體驗，推薦相關內容\n• 處理付款交易及客戶服務請求\n• 發送服務通知、更新及安全警告\n• 改進我們的演算法及服務品質\n• 遵守相關法律法規的要求\n\n特別說明：您提供的出生時間、生辰八字、星座等命理資料，僅用於在您本地設備上進行娛樂性質的命理演算，不用於任何形式的專業評估、價值判斷或現實決策參考。",
  "privacy.sec3.title": "三、資訊共享",
  "privacy.sec3.body": "我們不會將您的個人資訊出售給第三方。以下情況除外：\n• 獲得您的明確同意時\n• 為提供服務而委託的第三方服務商（如支付處理、雲端儲存），這些服務商受合約約束，不得將資訊用於其他目的\n• 法律要求或政府部門的合法要求\n• 為保護本公司、用戶或公眾的合法權益",
  "privacy.sec4.title": "四、資訊安全",
  "privacy.sec4.body": "我們採取以下措施保護您的資訊安全：\n• 使用 SSL/TLS 加密技術保護資料傳輸\n• 對敏感資訊進行加密儲存\n• 定期進行安全審計及漏洞掃描\n• 嚴格的員工資料存取權限管理\n• 資料備份與災難恢復機制\n\n儘管我們採取了上述措施，但網際網路環境存在固有風險，我們無法保證 100% 的安全。",
  "privacy.sec5.title": "五、Cookie 與追蹤技術",
  "privacy.sec5.body": "我們使用以下技術改善服務：\n• 功能性 Cookie：記住您的偏好設定（如主題、語言）\n• 分析性 Cookie：了解應用使用情況，持續最佳化\n• 第三方分析工具（如 Firebase Analytics）\n\n您可以在設備設定中管理 Cookie 偏好，但這可能影響部分功能的正常使用。",
  "privacy.sec6.title": "六、您的權利",
  "privacy.sec6.body": "您對您的個人資訊享有以下權利：\n• 存取權：您可以查看我們儲存的您的個人資訊\n• 更正權：您可以更新或更正不準確的資訊\n• 刪除權：您可以要求刪除您的帳號及相關資料\n• 撤回同意：您可以隨時撤回您的授權同意\n• 資料可攜性：您可以申請獲取您的個人資料副本\n\n如需行使以上權利，請透過客服管道聯繫我們。",
  "privacy.sec7.title": "七、未成年人保護",
  "privacy.sec7.body": "本應用不適合 18 歲以下未成年人使用。我們不會故意收集未成年人的個人資訊。如果您認為未成年人在未經授權的情況下向我們提供了個人資訊，請立即聯繫我們，我們將及時刪除相關資料。",
  "privacy.sec8.title": "八、資料保留",
  "privacy.sec8.body": "我們在以下期限內保留您的個人資訊：\n• 帳號活躍期間：持續保留服務所需的資訊\n• 帳號刪除後：基本資訊保留 30 天以處理退款等事宜\n• 交易記錄：依法保留 7 年\n• 匿名統計資料：長期保留用於研究目的\n\n超過保留期限的資料將被安全刪除或匿名化處理。",
  "privacy.sec9.title": "九、隱私政策更新",
  "privacy.sec9.body": "我們可能會定期更新本隱私政策。重大更改將透過應用通知或電子郵件提前通知您。繼續使用本應用即表示您接受更新後的隱私政策。\n\n本隱私政策最後更新日期：2026 年 5 月 18 日\n生效日期：2026 年 5 月 18 日",

  // terms page
  "terms.back_home": "返回首頁",
  "terms.title": "服務條款",
  "terms.subtitle": "服務條款",
  "terms.banner_alt": "服務條款",
  "terms.banner_title": "請仔細閱讀以下條款",
  "terms.banner_desc": "使用本應用即表示您已閱讀並同意本條款",
  "terms.badge1": "嚴謹科學",
  "terms.badge2": "順勢而為",
  "terms.badge3": "指引方向",
  "terms.disclaimer_title": "娛樂性質聲明",
  "terms.disclaimer_p1": "本應用功能及內容資訊僅供使用者娛樂使用，不等於專業測評，不代表價值評判，僅供娛樂參考，不可作為任何現實指導意義。所有分析結果請以理性、科學的態度對待，不應作為法律、醫療、財務等任何領域的決策依據。",
  "terms.disclaimer_b1": "我們基於實際情況嚴謹、科學地遵循命理之道，不恐嚇、不製造焦慮。遇到不利運勢，理性分析，提供化解之道。",
  "terms.disclaimer_b2": "運勢流年是順勢而為的參考，而非不可更改的定論；命理是認識自我的工具，而非束縛命運的枷鎖。",
  "terms.disclaimer_b3": "我們深入剖析根源、清晰指引\"怎麼辦\"，讓命理真正服務於生活，成為助力前行的實用指引。",
  "terms.contact_title": "如有疑問，歡迎聯繫我們",
  "terms.sec1.title": "一、服務說明",
  "terms.sec1.body": "命理乾坤（以下簡稱\"本應用\"）是一款集八字命理、紫微斗數、塔羅占卜、黃曆查詢等傳統玄學服務於一體的行動應用程式。本服務條款適用於所有使用本應用的用戶。\n\n通過下載、安裝或使用本應用，即表示您同意受本條款約束。如您不同意本條款的任何部分，請勿使用本應用。",
  "terms.sec2.title": "二、用戶帳號",
  "terms.sec2.body": "• 您須年滿 18 歲方可使用本應用的全部功能。\n• 您有責任維護您帳號的安全，包括保管好您的登入密碼。因您的疏忽導致帳號被盜用，本應用不承擔責任。\n• 您不得轉讓、出借或出售您的帳號給第三方。\n• 若發現帳號被盜用，請立即聯繫我們的客服團隊。",
  "terms.sec3.title": "三、付費服務與退款政策",
  "terms.sec3.body": "• 本應用提供金幣充值、問卷購買、VIP 會員等付費服務。所有付費服務均為自願購買。\n• 虛擬金幣及虛擬物品一經購買，原則上不予退款，除非因本應用服務故障導致的損失。\n• VIP 會員費用按所選套餐計算，到期後不自動續費。\n• 如因本應用技術問題導致服務無法正常使用，我們將酌情補償。",
  "terms.sec4.title": "四、用戶行為規範",
  "terms.sec4.body": "• 您同意不以任何方式干擾本應用的正常營運。\n• 您不得使用自動化工具大量獲取或操作本應用資料。\n• 您不得在本應用內發布任何違法、有害、騷擾性或虛假的內容。\n• 違反上述規範，本應用有權暫停或終止您的帳號。",
  "terms.sec5.title": "五、命理服務免責聲明",
  "terms.sec5.body": "5.1 本應用功能及內容資訊僅供用戶娛樂使用，不等於專業測評，不代表價值評判，僅供娛樂參考，不可作為任何現實指導意義。\n5.2 本應用提供的命理、占卜及相關服務純屬娛樂性質，不構成任何形式的專業建議（包括但不限於法律、醫療、財務建議）。\n5.3 本應用不保證命理結果的準確性，用戶應以理性、科學的態度看待相關結果。命理是認識自我的工具，而非束縛命運的枷鎖，運勢流年是順勢而為的參考，而非不可更改的定論。\n5.4 用戶因參考本應用命理結果而做出的任何決策，本應用不承擔任何責任。",
  "terms.sec6.title": "六、智慧財產權",
  "terms.sec6.body": "• 本應用的所有內容，包括但不限於文字、圖片、演算法、介面設計，均受智慧財產權法律保護。\n• 未經書面許可，您不得複製、修改、分發或商業使用本應用的任何內容。\n• 用戶在本應用內生成的個人命理報告僅供個人使用，不得轉售或商業使用。",
  "terms.sec7.title": "七、服務變更與終止",
  "terms.sec7.body": "• 本應用保留在任何時候修改、暫停或終止服務的權利，並會提前通知用戶。\n• 因不可抗力（如自然災害、政策變化等）導致的服務中斷，本應用不承擔責任。\n• 如本應用終止服務，將提前 30 天通知用戶，並對未消耗的付費金幣按照相關規定處理。",
  "terms.sec8.title": "八、條款修改",
  "terms.sec8.body": "本應用保留隨時修改本服務條款的權利。修改後的條款將在本應用內公布，繼續使用本應用即視為接受修改後的條款。重大變更將透過應用通知或郵件方式提前告知用戶。\n\n本條款最後更新日期：2026 年 5 月 18日",

  // guide page
  "guide.title": "洞悉命理，\n掌握乾坤",
  "guide.description": "——做自己的命運主宰者",
  "guide.enter_home": "進入首頁",
  "guide.contact_us": "聯繫我們",
  "guide.skip": "跳過引導",
  "guide.screen": "第{{count}}屏",
  "guide.scroll": "滾動",

  // about page
  "about.title": "關於我們",
  "about.subtitle": "關於我們",
  "about.brand": "命理乾坤",
  "about.brand_slogan": "\"洞悉命理，掌控乾坤\"",
  "about.intro": "命理乾坤是一款融合中西方九大命理流派的智能分析應用。我們以 AI 技術復現大師級推理能力，將紫微斗數、八字命理、奇門遁甲等傳統智慧與現代工程嚴謹性相結合，為每一位用戶提供透明、可追溯的命理分析體驗。",
  "about.mission_title": "使命與願景",
  "about.mission_p1": "我們相信，命理是認識自我的工具，而非束縛命運的枷鎖。運勢流年是順勢而為的參考，而非不可更改的定論。",
  "about.mission_p2": "我們的願景是讓每一位用戶都能在關鍵節點看清自己的處境，發現被忽視的能量，將天賦與機遇對齊，成為自己命運的主宰者。",
  "about.mission_p3": "我們立志以傳播中華優秀傳統文化為己任，將八字命理、紫微斗數、奇門遁甲等千年智慧以現代方式呈現，讓更多人認識中華文化之美、傳統哲學之深，為廣大學者與文化愛好者提供有意思的命理研習平台。",
  "about.values_title": "核心理念",
  "about.value1_title": "嚴謹科學",
  "about.value1_desc": "基於實際命理規則推演，不恐嚇、不製造焦慮，理性分析並提供化解之道。",
  "about.value2_title": "順勢而為",
  "about.value2_desc": "運勢流年是順勢而為的參考，命理是認識自我的工具。",
  "about.value3_title": "指引方向",
  "about.value3_desc": "深入剖析根源，清晰指引\"怎麼辦\"，讓命理真正服務於生活。",
  "about.value4_title": "透明可追溯",
  "about.value4_desc": "每一步推理完全可見，從時間校準到多派融合，結論有據可依。",

  // contact page
  "contact.title": "聯繫我們",
  "contact.subtitle": "聯繫我們",
  "contact.methods_title": "聯繫方式",
  "contact.email_label": "郵件支持",
  "contact.email_address": "dazhuotech@gmail.com",
  "contact.email_reply": "48小時內回覆",
  "contact.send_email": "發送郵件",
  "contact.feedback_title": "意見反饋",
  "contact.type_feature": "功能建議",
  "contact.type_bug": "問題反饋",
  "contact.type_account": "賬號問題",
  "contact.type_other": "其他",
  "contact.feedback_placeholder": "請描述您遇到的問題或建議，我們將認真閱讀每一條反饋...",
  "contact.char_count": "{{count}}/500",
  "contact.submit_success": "提交成功",
  "contact.submit": "提交反饋",
  "contact.submitted": "已提交",
  "contact.submit_error": "提交失敗，請稍後重試",

  // 404 page
  "notFound.title": "頁面尚未生成",
  "notFound.hint": "告訴我這個頁面的資訊，我來幫您生成",
  marquee: {
    currentMaster: '當前命主：',
    solarDate: '公曆：',
    dayMasterLabel: '日主：',
    dayMasterFallback: '己',
    wearing: '當前佩戴：',
  },
};